// @flow
import React from "react"
import type { Reservation } from "data/reservations/types"
import { momentFromDateString } from "data/units/date/helpers"
import type { DateString } from "data/units/date/types"
import { Text } from "componentsStyled/Typography/Texts"
import { DateTileWrap } from "./styled"

type Props = {|
  start: DateString,
  end: DateString,
|}

const DateTile = ({ start, end }: Props) => {
  const momentStart = momentFromDateString(start)
  const momentEnd = momentFromDateString(end)

  if (momentStart.isSame(momentEnd, "month")) {
    if (momentStart.isSame(momentEnd, "day")) {
      return (
        <DateTileWrap>
          <Text small book black>
            {momentStart.format("MMM")}
          </Text>
          <Text small>{momentStart.format("D")}</Text>
        </DateTileWrap>
      )
    }

    return (
      <DateTileWrap>
        <Text small book black>
          {momentStart.format("MMM")}
        </Text>
        <Text small>
          {momentStart.format("D")}-{momentEnd.format("D")}
        </Text>
      </DateTileWrap>
    )
  }

  return (
    <DateTileWrap>
      <Text small>From</Text>
      <Text small book black>
        {momentStart.format("MMM D")}
      </Text>
      <Text small>To</Text>
      <Text small book black>
        {momentEnd.format("MMM D")}
      </Text>
    </DateTileWrap>
  )
}

export default DateTile



// WEBPACK FOOTER //
// ./src/components/ReservationList/ReservationTile/DateTile/index.js